// extracted by css-extract-rspack-plugin
export default {"Wrapper":"WebGLFooter-module__Wrapper__qr5ms","Canvas":"WebGLFooter-module__Canvas__Bw9hs"};